import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import plTranslations from './locales/pl/translations.js';
import enTranslations from './locales/en/translations.js';
const resources = {
  pl: {
    translation: plTranslations,
  },
  en: {
    translation: enTranslations,
  },
};
i18next.use(initReactI18next).init({
  resources,
  lng: 'pl',
  interpolation: {
    escapeValue: false,
  },
  debug: process.env.REACT_APP_ENVIRONMENT !== 'production',
});
export default i18next;
